import React, { useState, useEffect, useRef, MutableRefObject } from 'react'

interface StyledComponent {
  className?: string;
  children?: React.ReactNode[] | React.ReactNode;
}

export type positionLocation = 'left' | 'center' | 'right';

export const DropdownMenu: React.FC<StyledComponent> = ({ className, children, ...props }) => {
  const dropdownPositionRef = useRef() as MutableRefObject<HTMLDivElement>
  const [isDropdownRendered, setDropdownRendered] = useState<boolean>(false)
  const [positionLocation, setPositionLocation] = useState<positionLocation | undefined>(undefined)

  /*
   * Apply transform method before the render, so the user does not see a jarring experience
   */
  useEffect(() => {
    const dropdownEl = dropdownPositionRef.current
    const dropdownLocation = dropdownEl.getBoundingClientRect()
    const adjustedViewportRightEdge = window.innerWidth - 15
    const adjustedViewportLeftEdge = 50

    const dropdownX = dropdownLocation.x || dropdownLocation.left

    const widthOfDropdownElement = dropdownLocation.right - dropdownX
    const adjustedDropdownElementRightEdge = dropdownLocation.right - (widthOfDropdownElement / 2) // move default position of "right" to "center"
    const adjustedDropdownElementLeftEdge = dropdownX - (widthOfDropdownElement / 2) // move default position of "center" to "left"

    let position: positionLocation | undefined
    if (adjustedDropdownElementLeftEdge < adjustedViewportLeftEdge) {
      position = 'left'
    } else if (adjustedDropdownElementRightEdge > adjustedViewportRightEdge) {
      position = 'right'
    } else {
      position = 'center'
    }

    setPositionLocation(position)
    setDropdownRendered(true)
  }, [dropdownPositionRef])

  return (
    <div
      ref={dropdownPositionRef}
      className={`
        ${className || ''} ch-c-dropdown-menu ch-c-dropdown-location-${positionLocation} 
        ${isDropdownRendered ? '' : 'ch-c-hide-dropdown'}
      `}
      data-testid='dropdown-menu'
    >
      {children}
    </div>
  )
}

export const DropdownMenuFooter: React.FC<StyledComponent> = ({ children, ...props }) => {
  return (
    <div className='ch-c-dropdown-menu__footer'>{children}</div>
  )
}
